/**
 * Stack routes of the native screens added by the `extras3` admin-module group.
 */
import lazyScreen from '../../components/lazyScreen';

// Example: {name: 'MyScreen', component: lazyScreen(() => import('../../screens/adminModules/extras3/MyScreen'))}
const ROUTES = [
    {name: 'Extras3FormScreen', component: lazyScreen(() => import('../../screens/adminModules/extras3/Extras3FormScreen'))},
    {name: 'Extras3PayrollRunScreen', component: lazyScreen(() => import('../../screens/adminModules/extras3/Extras3PayrollRunScreen'))},
    {name: 'Extras3AiCreditsScreen', component: lazyScreen(() => import('../../screens/adminModules/extras3/Extras3AiCreditsScreen'))},
];

export default ROUTES;
